import { FC, useState } from 'react';
import { CandidateType } from '../Candidates/Candidates';
import { CurrencyInput } from '../CustomSplit/CurrencyInput';
import theme from 'config/theme';
import { getAmountValidation } from '../CustomSplit/utils';
import { RecipientDetailSection } from 'store/donatePage/types';
import classNames from 'classnames';
import Icon, { IconNames } from 'components/Icon';
import { ENV_CONFIG } from 'config/environment';
import { sanitizeHtml } from 'helpers/utils';

interface CandidateWithDetails extends CandidateType {
  header_1?: string;
  header_2?: string;
  summary?: string;
  sections?: RecipientDetailSection[];
}

interface Props {
  candidate: CandidateWithDetails;
  onChangeAmount: (candidate: CandidateType, amount: number, index: number) => void;
  index: number;
}

export const Recipient: FC<Props> = ({ candidate, onChangeAmount, index }) => {
  const { validate } = getAmountValidation(candidate);
  const [detailVisible, setDetailVisible] = useState(false);

  const onChange = (value?: number) => {
    onChangeAmount(candidate, value || 0, index);
  };

  const showHideDetail = () => {
    setDetailVisible(prevState => !prevState);
  };

  const hasDetail = !!(candidate.sections?.length || candidate.summary);

  return (
    <div className="recommendation-card">
      <div className={classNames('recommendation-card-content', { visible: detailVisible })}>
        <div className="candidate-grid">
          <img
            src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${
              candidate.misc_ids?.photo_id
            }.jpg`}
            alt={`${candidate.recipient_name} photo`}
            className="candidate-photo"
          />
          <div className="column">
            <span className="body-small-text semibold">{candidate.recipient_name}</span>
            <span className="utility-text color-black shadow-7">{candidate.header_1}</span>
            <span className="utility-text color-black shadow-7">{candidate.header_2}</span>
          </div>
        </div>
        <div className="candidate-amount">
          <CurrencyInput
            id={`${candidate.recipient_id}-custom-amount-input`}
            validate={validate}
            value={candidate.donationAmount}
            onChange={onChange}
          />
          {hasDetail && (
            <div
              className={classNames('show-more-less-row', {
                visible: detailVisible,
              })}
              onClick={showHideDetail}
            >
              <span className="utility-text color-black shadow-7">
                {!detailVisible ? 'Learn More' : 'Show Less'}
              </span>
              <Icon
                name={!detailVisible ? IconNames.PlusCircle : IconNames.MinusCircle}
                size={14}
                color={theme.colors.inkBlue}
              />
            </div>
          )}
        </div>
      </div>

      {detailVisible && hasDetail && (
        <div className="recipient-detail-expanded">
          <div className="recipient-detail-content">
            <div className="candidate-details">
              <span className="body-small-text">{candidate.summary}</span>
            </div>
            {candidate.sections?.map((detail, index) => (
              <div className="candidate-details" key={index}>
                <span className="body-small-text title">{detail.label}</span>
                <span
                  className="body-small-text"
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(detail.value) }}
                />
              </div>
            ))}
            <div
              className={classNames('show-more-less-row', { visible: !detailVisible })}
              onClick={showHideDetail}
            >
              <span className="utility-text color-black shadow-7">
                {!detailVisible ? 'Learn More' : 'Show Less'}
              </span>
              <Icon
                name={!detailVisible ? IconNames.PlusCircle : IconNames.MinusCircle}
                size={14}
                color={theme.colors.inkBlue}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
